import React from 'react'
import PropTypes from 'prop-types'
import { useDrop } from 'react-dnd'

const TargetBox = props => {
	const { render, onDrop, accepts } = props
	const handleDrop = (item, monitor) => {
		if (onDrop) {
			const file = monitor.getItem().files[0]
			onDrop(file)
		}
	}

	const [{ canDrop, isOver }, drop] = useDrop({
		accept: accepts,
		drop: handleDrop,
		collect: monitor => ({
			isOver: monitor.isOver(),
			canDrop: monitor.canDrop()
		})
	})

	const isActive = canDrop && isOver

	return(
		<div ref={drop} style={{ display: 'inline-block' }}>
			{render({
				isOver,
				canDrop,
				isActive
			})}
		</div>
	)
}

TargetBox.propTypes = {
	render: PropTypes.func.isRequired,
	onDrop: PropTypes.func.isRequired
}

export default TargetBox

